import React from "react";

export default function DoesMyBirthtime(props) {
  return (
    <>
      <div id="what-if-cont">
        <a
          href="#"
          className="explain-what-if"
          data-bs-toggle="modal"
          data-bs-target="#what-if"
        >
          Does my birth time affect the chart?
        </a>

        <div
          className="modal fade"
          id="what-if"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="what-if"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Does my birth time affect the chart?
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Leaving time information out will still produce an accurate
                  chart, but may affect the final piece.
                </p>
                <p>
                  For example, a given necklace may include different aspects
                  and look different with or without the time information.
                </p>
                <p>
                  If you choose not to enter your birth time and mark the
                  checkbox, our algorithm will disregard the time data when
                  creating your necklace.
                </p>

                <p>
                  For more technical information on how we account for this,{" "}
                  <a href="/faq#birth-time">see our FAQ here.</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
